<template>
    <div
        class="item-wrap"
        :style="topBorderStyle"
    >
        <p
            v-if="response.type === 'TEXT'"
            class="phrase">{{response.answer}}
        </p>

        <p class="parametr">
            <span class="parametr--label">
              {{ $t('model.nlu-model.sidebar.testpreview.responseitem.context') }}
            </span> {{response.context}}
        </p>

        <div class="row">
            <p class="parametr">
                <span class="parametr--label">
                  {{ $t('model.nlu-model.sidebar.testpreview.responseitem.responseType') }}
                </span> {{response.type}}
            </p>

            <p class="parametr--confidence">{{response.score}}%</p>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    response: Object
  },

  computed: {
    topBorderStyle () {
      return {
        borderTop: `solid 3px rgba(64, 159, 236, ${this.response.score / 100})`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-wrap {
    display: flex;
    flex-direction: column;
    max-height: 90px;
    padding: $sp-2;
    border-radius: 4px;
    background-color: $or-grey-light;
    margin-bottom: $sp-3;

    &:hover {
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
        transition: all .1s ease-in;
        cursor: pointer;
    }

    .row {
        display: flex;
        justify-content: space-between;
    }

    p {
        margin: 0;
    }

    .phrase {
        font-size: 14px;
        line-height: 21px;
        margin-bottom: $sp-2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $or-black-blue;
    }

    .parametr {
        font-size: 12px;
        color: $or-black-blue;
        margin-bottom: $sp-2;

        &--label {
            color: $or-grey-dark;
        }

        &--confidence {
            font-weight: bold;
            font-size: 12px;
        }
    }
}
</style>
